export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    computed: {
        activeItem() {
            return this.uniqueItems.find(item => item.val === this.value);
        },
        uniqueItems() {
            return this.items.map((item, idx) => {
                const name = this.id;
                const id = `${ this.id }-${ idx }`;
                const singleBoolExtension = this.isBooleanCheckbox ? { val: null, label: item.val } : {};

                return Object.assign({}, item, { name, id }, singleBoolExtension);
            });
        },
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/mixins/form/form-field-items/index.js